import { LoaderType, NextgenImage, useTranslation } from '@nextgen-web-framework/all';
import { uniqueId } from '@nextgen-web-framework/core';
import styles from './ProductThumbnail.module.scss';

interface ProductThambnailCardProps {
  productImageUrls?: string[];
}
const MAX_PRODUCT = 4;
const ProductThumbnailCard = (props: ProductThambnailCardProps) => {
  const t = useTranslation();
  return (
    <div className={styles['delivery-package-card-product-thumbnails']}>
      <div className={styles['delivery-package-card-product-count']}>
        {t('order.deliveryTracking.items').replace('{{count}}', props.productImageUrls?.length.toString() ?? '')}
      </div>
      <div className={styles['delivery-package-card-product-thumbnails-list']}>
        {props.productImageUrls
          ?.filter((item) => item)
          .slice(0, MAX_PRODUCT)
          .map((image, index) => {
            if (props.productImageUrls && props.productImageUrls?.length > MAX_PRODUCT && index === MAX_PRODUCT - 1) {
              return (
                <div
                  key={uniqueId()}
                  className={`${styles['delivery-package-card-product-thumbnail-item']} ${styles['last-thumbnail-item']}`}
                >
                  <NextgenImage src={image} loaderType={LoaderType.WEBFONTS} alt={''} />
                  <div className={styles['delivery-package-card-product-more']}>
                    +{props.productImageUrls?.length - MAX_PRODUCT}
                  </div>
                </div>
              );
            }
            return (
              <div key={uniqueId()} className={styles['delivery-package-card-product-thumbnail-item']}>
                <NextgenImage src={image} loaderType={LoaderType.WEBFONTS} alt={''} />
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ProductThumbnailCard;
